module.exports = __webpack_public_path__ + "assets/stemIcon3.c01fe884.svg";